// Maps the API tag `color` field to an Ant Design Tag color
export const COLOR_TO_TAG = {
  green: "success",
  orange: "warning",
  red: "error",
  default: "default"
}

export const PAYMENT_FILTERS = ["Paid", "Balance Due"]
export const WAIVER_FILTERS = ["Signed", "Unsigned"]
export const CHECKIN_FILTERS = ["Not checked-in", "Checked-in", "Partial check-in", "Checked-out"]

// Maps the display label to the derived check-in state (see CheckIn/checkInUtils)
export const CHECKIN_STATE_MAP = {
  "Not checked-in": "pending",
  "Checked-in": "in",
  "Partial check-in": "partial",
  "Checked-out": "out"
}

export const EMPTY_FILTERS = { payment: [], waiver: [], checkin: [] }
